import(/* webpackMode: "eager", webpackExports: ["ServicesPage"] */ "/app/src/app/(shop)/services/[slug]/components/servicesPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MerchantFooter"] */ "/app/src/components/merchantFooter/merchantFooter.tsx");
